import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function HeaderNav() {
  return (
    <header
      data-testid="header-nav"
      className="fixed inset-x-0 top-0 z-40 border-b border-[#D4AF37]/10 bg-[#0B0B0D]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-3">
          <span className="font-display text-2xl tracking-wide text-[#F5F3EF]">
            Valeur <span className="italic text-[#D4AF37]">Prestige</span>
          </span>
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-stone-500 sm:block">
            Paris · Île-de-France
          </span>
        </Link>
        <nav className="hidden items-center gap-8 lg:flex" data-testid="main-nav">
          <Link to="/vendre" data-testid="nav-link-vendre" className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#E5C158] transition-colors hover:text-amber-200">
            Vendre
          </Link>
          <a href="#manifeste" data-testid="nav-link-manifeste" className="font-mono text-[11px] uppercase tracking-[0.25em] text-stone-400 transition-colors hover:text-[#E5C158]">
            Manifeste
          </a>
          <a href="#methode" data-testid="nav-link-methode" className="font-mono text-[11px] uppercase tracking-[0.25em] text-stone-400 transition-colors hover:text-[#E5C158]">
            Méthode
          </a>
          <a href="#conseiller" data-testid="nav-link-conseiller" className="font-mono text-[11px] uppercase tracking-[0.25em] text-stone-400 transition-colors hover:text-[#E5C158]">
            Votre conseiller
          </a>
          <a href="#faq" data-testid="nav-link-faq" className="font-mono text-[11px] uppercase tracking-[0.25em] text-stone-400 transition-colors hover:text-[#E5C158]">
            Questions
          </a>
        </nav>
        <Link to="/estimation" data-testid="nav-cta-estimation" className="btn-gold !px-5 !py-2.5 !text-xs">
          Estimer mon bien <ArrowUpRight size={14} />
        </Link>
      </div>
    </header>
  );
}
